import Video from '@/data/Video';
import IVideoSort from '@/utils/IVideoSort';
import Region from '@/utils/Region';
import VideoPriorityHelper from './VideoPriorityHelper';

export default class VideoSortByDefault implements IVideoSort {

  private _channelName: string | undefined = undefined;
  private _fallbackSort: IVideoSort;
  private _region: Region | undefined;

  constructor(fallbackSort: IVideoSort, region: Region | undefined, channelName: string | undefined) {
    
    this._fallbackSort = fallbackSort;
    this._channelName = channelName;
    this._region = region;
  }

  public getComparator(): (video1: Video, video2: Video) => number {

    return (video1: Video, video2: Video) => {

      let v1Prio = video1.priority;
      let v2Prio = video2.priority;

      // Hint: Use the lowest priority if a video has no valid priority value.
      if(!v1Prio) v1Prio = VideoPriorityHelper.defaultPrio;
      if(!v2Prio) v2Prio = VideoPriorityHelper.defaultPrio;
      
      if(v1Prio === v2Prio) {
        return this._fallbackSort.getComparator()(video1, video2);
      }
      return v1Prio - v2Prio;
    }
  };

  public sort(videos: Array<Video>, calcOwnPrio?: boolean): Array<Video> {
    if(!videos) return videos;
    
    if(calcOwnPrio) {
      const videoPriorityHelper = new VideoPriorityHelper(this._region, this._channelName);
      for(const video of videos) {
        videoPriorityHelper.extractAndSetPrio(video);
      }
    }
    return videos.sort(this.getComparator());
  }
}
